'use client';
/** @jsxImportSource @emotion/react */

import type { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

/* eslint-disable @typescript-eslint/no-empty-interface */
import MuiTextField from '@mui/material/TextField';

type ExcludedMuiProps =
  | 'color'

  /**
   * TODO: ZDS-191: Add support for multiline (https://serko.atlassian.net/browse/ZDS-191)
   */
  | 'maxRows'
  | 'minRows'
  | 'multiline'
  | 'rows';

interface TextFieldProps extends Omit<MuiTextFieldProps, ExcludedMuiProps> {}

export type { TextFieldProps };
export const TextField: React.FC<TextFieldProps> = MuiTextField;

TextField.displayName = 'TextField';
